import type { StandardPayment } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveTransferList = createApiThunk<StandardPayment[], void>(
  "transfers/retrieveTransferList",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listTransfers();
  },
);
